/**
 * Converts an object with operand keys (A1, B2, etc.) to an object with column IDs as keys.
 *
 * @param {Object} tableOperandLookup  // { A1: value, B2: value, AA1: value, ... }
 * @param {Array} columnsWithOperands // [ { _id: 'columnId1', operand: 'A' }, { _id: 'columnId2', operand: 'B' }, ... ]
 * @returns Object // { columnId1: value, columnId2: value, ... }
 */
function convertOperandLookupToColumnLookup(tableOperandLookup, columnsWithOperands) {
  const newObj = {};

  // Sort the columnsWithOperands so that longer operands come first.
  const sortedOperands = columnsWithOperands.slice().sort((a, b) => b.operand.length - a.operand.length);

  // Iterate over each key in the original object.
  for (const key in tableOperandLookup) {
    if (Object.hasOwnProperty.call(tableOperandLookup, key)) {
      // Find the first operand that matches the beginning of the key.
      const match = sortedOperands.find((item) => key.startsWith(item.operand));

      // If found, use the _id as the new key; otherwise, keep the original key.
      if (match) {
        newObj[match._id] = tableOperandLookup[key];
      } else {
        newObj[key] = tableOperandLookup[key];
      }
    }
  }

  return newObj;
}

export default convertOperandLookupToColumnLookup;
